module.exports = __webpack_public_path__ + "img/fig04.a93a60bf.jpg";